import { computed, onMounted, ref } from 'vue'

/**
 * Custom composable function that adds a delay to a button.
 * The button is temporarily disabled for a specified timeout period.
 * @returns An object containing the computed property `isTemporarilyDisabled`.
 */
export const useButtonDelay = () => {
  const DELAY_TIMEOUT = 500

  const buttonDelayIsDisabled = ref<boolean>(true)

  const isTemporarilyDisabled = computed<boolean>(() => buttonDelayIsDisabled.value)

  function startDelay(): void {
    setTimeout(() => {
      buttonDelayIsDisabled.value = false
    }, DELAY_TIMEOUT)
  }

  onMounted(startDelay)

  return {
    isTemporarilyDisabled
  }
}
